var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9998 0C12.5558 0 13.9345 0.788567 14.9117 1.90722C15.8877 3.02446 16.4996 4.50982 16.4996 5.98423C16.4996 7.45831 15.8231 9.18778 14.8421 10.5415C13.8741 11.8773 12.4941 13 10.9998 13C9.522 13 8.14195 11.9812 7.16216 10.6727C6.1719 9.35022 5.5 7.61854 5.5 5.98423C5.5 2.73765 7.91909 0 10.9998 0ZM10.9998 1C8.55787 1 6.5 3.19927 6.5 5.98423C6.5 7.36569 7.07799 8.8919 7.96263 10.0733C8.85773 11.2688 9.9776 12 10.9998 12C12.0057 12 13.1256 11.2061 14.0324 9.95467C14.9263 8.72109 15.4996 7.19268 15.4996 5.98423C15.4996 4.77612 14.9922 3.51936 14.1586 2.56511C13.3263 1.61229 12.2051 1 10.9998 1Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 13.5C7.5 13.7761 7.27614 14 7 14L6.80543 14.0045L6.54384 14.0195L6.2225 14.0474C6.16437 14.0533 6.10405 14.0598 6.04169 14.067C5.31363 14.151 4.58655 14.302 3.91356 14.535C2.14022 15.1488 1.08996 16.1883 1.00552 17.7881L1 18V22.5C1 22.7761 0.776142 23 0.5 23C0.25454 23 0.0503917 22.8231 0.00805569 22.5899L0 22.5V18C0 15.783 1.37438 14.3557 3.58644 13.59C4.33532 13.3308 5.13168 13.1654 5.92706 13.0736C6.11231 13.0522 6.2889 13.0359 6.45498 13.024L6.79507 13.005L7 13C7.27614 13 7.5 13.2239 7.5 13.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2049 13.005L15 13C14.7239 13 14.5 13.2239 14.5 13.5C14.5 13.7761 14.7239 14 15 14C15.0264 14 15.056 14.0003 15.0885 14.0011L15.3174 14.0105L15.6098 14.0317L15.9583 14.067C16.6863 14.151 17.4134 14.302 18.0864 14.535C19.9368 15.1755 20.9999 16.2795 20.9999 18L21 22.5C21 22.7761 21.2239 23 21.5 23C21.7761 23 22 22.7761 22 22.5L21.9999 18L21.9947 17.7655C21.9007 15.6819 20.5465 14.3284 18.4135 13.59C17.6646 13.3308 16.8683 13.1654 16.0729 13.0736C15.7951 13.0415 15.5367 13.0209 15.304 13.0094L15.2049 13.005Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.ef77d46c3610c14d1533a3fbb475bdf5.svg";
export { ForwardRef as ReactComponent };